var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vuex-breadcrumb'),_c('collection-image-create',{attrs:{"collection_id":_vm.id}}),_c('b-button',{attrs:{"block":"","variant":"primary"},on:{"click":_vm.callDone}},[_vm._v("Done")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }